import { Avatar } from "antd";
import { useState } from "react";
import "./styles/SideDrawer.css";
import { useDispatch } from "react-redux";
import { setUser } from "../Redux/Feature/loginSlice";
import { PublicUserInfo } from "../Pages/Auth/Helper";
import { stringAvatar } from "../Utils/avatar";
import { useEffect } from "react";
import { useCountryStateCityProvider } from "../Providers/Common/CountyStateCity";

const ProfileDropdown = () => {
  const dispatch = useDispatch();
  const [details, setDetails] = useState({
    about: "",
    industry: "",
    industryExperience: "",
    username: "",
    portfolio: "",
    location: "",
    linkedin: "",
    profilePhoto: null,
    resume: null,
    skills: [],
  });
  const userId = localStorage.getItem("userId");
  const { getStatesByCountry, getCountries } =
    useCountryStateCityProvider();
  useEffect(() => {
    PublicUserInfo({ userId: userId })
      .then(async (res) => {
        setDetails(res.data.result);
        if (res.data.result.state && res.data.result.country) {
          const state = await getStatesByCountry(
            res.data.result.country,
            res.data.result.state
          );
          const country = await getCountries(res.data.result.country);
          dispatch(
            setUser({
              ...res.data.result,
              state: state.name,
              country: country.name,
            })
          );
        } else {
          dispatch(setUser(res.data.result));
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  return (
    <Avatar
      src={details?.profilePhoto}
      sx={{ width: 100, height: 100 }}
      {...stringAvatar(`${details.firstName} ${details.lastName}`)}
    />
  );
};
export default ProfileDropdown;
